module.exports = "../assets/welcome-81bef2f6.png";